import { render, staticRenderFns } from "./FaxChannelForm.vue?vue&type=template&id=30ee38a3"
import script from "./FaxChannelForm.vue?vue&type=script&lang=js"
export * from "./FaxChannelForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports